import type { PropsWithChildren } from 'react';
import cx from 'classnames';
import { snakeCase } from 'lodash';

import { useOnNavigateToSectionClick } from 'Components/QuickLinks';
import TextLink from 'Components/shared/TextLink/TextLink';
import { applyCypressData } from 'Utilities/helpers';

import styles from './RatingItem.module.scss';

interface RatingItemProps {
	analyticsCategory?: string;
	clickableLinks?: boolean;
	id: string;
	onNavigate?: () => void;
	text: string;
}

export const RatingItem: React.FC<PropsWithChildren<RatingItemProps>> = ({
	analyticsCategory = '',
	children,
	clickableLinks = false,
	id,
	onNavigate,
	text,
}) => {
	const onNavigateToSectionClick = useOnNavigateToSectionClick({
		analytics: {
			category: analyticsCategory,
		},
		onNavigate,
		source: 'ratingItem',
	});

	const onClick = () => {
		const label = snakeCase(text);
		onNavigateToSectionClick(id, label);
	};

	return (
		<div className={styles.item}>
			<span className={styles.stat} {...applyCypressData(`ratingItem-${id}-children`)}>
				{children}
			</span>
			{clickableLinks ? (
				<TextLink
					classNames={{ container: styles.link, text: styles.text }}
					{...applyCypressData(`ratingItem-${id}-textLink`)}
					onClick={onClick}
					onKeyPress={onClick}
					tabIndex={0}
					text={text}
				/>
			) : (
				<span className={cx(styles.text, styles.link)}>{text}</span>
			)}
		</div>
	);
};
